import { GenericComboDTO } from "medere-ui-framework";

export interface MedereEntityContactDTO {
  medereentity_contact: number;
  medereentity_contacttype: number;
  contact_type: string;
  medereentity: number;
  contactname: string;
  contactlastname:string;
  contactemail: string;
  contactphone: string;
  address: number;
  addressdesc: string;
  contact_types_string: string; // STRING PARA FILTRADO
  addresstypes: GenericComboDTO[];
  contact_types: GenericComboDTO[];
  hasChanges?: boolean;
}

export const defaultMedereEntityContactDTO: MedereEntityContactDTO = {
  medereentity_contact: 0,
  medereentity_contacttype: 0,
  contact_type: "",
  medereentity: 0,
  contactname: "",
  contactlastname:"",
  contactemail: "",
  contactphone: "",
  address: 0,
  addressdesc: "",
  contact_types_string: "",
  addresstypes: [],
  contact_types: []
};
